import api from 'lib/trpcClient';

export default function useEarliestAvailableLedgerDate({
  vehicleId,
  limitByCapitalActions,
}: {
  vehicleId: string;
  limitByCapitalActions?: boolean;
}) {
  const { data: earliestAvailableLedgerDate } =
    api.vehicle.getEarliestLedgerDate.useQuery({
      vehicleId,
      limitByCapitalActions,
    });

  return earliestAvailableLedgerDate;
}
